import { create } from 'zustand';
import type { User } from '../types';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  logout: () => Promise<void>;
  checkSession: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  setLoading: (isLoading) => set({ isLoading }),
  logout: async () => {
    await import('../lib/api').then((m) => m.apiFetch('/api/auth/logout', { method: 'POST' }));
    set({ user: null, isAuthenticated: false });
  },
  checkSession: async () => {
    try {
      const res = await import('../lib/api').then((m) => m.apiFetch('/api/auth/me'));
      if (res.ok) {
        const data = (await res.json()) as { user: User | null };
        set({ user: data.user, isAuthenticated: !!data.user });
      } else {
        set({ user: null, isAuthenticated: false });
      }
    } catch {
      set({ user: null, isAuthenticated: false });
    } finally {
      set({ isLoading: false });
    }
  },
}));
